import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format user ID with role prefix for display
 * @param id - User ID (integer)
 * @param userType - User role: 'admin' | 'therapist' | 'client'
 * @returns Formatted ID like "AD-46", "TH-12", "HO-123"
 */
export function formatUserId(id: number, userType: 'admin' | 'therapist' | 'client'): string {
  const prefix = {
    admin: 'AD',
    therapist: 'TH',
    client: 'HO'
  }[userType];
  return `${prefix}-${id}`;
}

/**
 * Parse formatted user ID back to ID and type
 * @param formattedId - Formatted ID like "AD-46"
 * @returns Object with id and userType, or null if invalid
 */
export function parseUserId(formattedId: string): { id: number; userType: 'admin' | 'therapist' | 'client' } | null {
  const match = formattedId.match(/^(AD|TH|HO)-(\d+)$/);
  if (!match) return null;
  
  const typeMap = { AD: 'admin', TH: 'therapist', HO: 'client' } as const;
  return {
    id: parseInt(match[2], 10),
    userType: typeMap[match[1] as keyof typeof typeMap]
  };
}
